/**
 * Barrett M82. Semi-automatic .50 BMG: ten rounds, the hardest hit and the hardest kick in the
 * game, and a gun that is not shot on the move.
 */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const M82 = {
  id: 'm82',
  label: 'Barrett M82',
  classId: 'sniper',
  caliber: '.50 BMG',
  fireMode: 'semi',
  roundsPerMinute: 70,
  magSize: 10,
  reserveAmmo: 30,
  reloadSeconds: 4.2,
  emptyReloadSeconds: 5,
  reloadStyle: 'magazine',
  damage: 175,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 200, zeroMetres: 800, minScale: 0.7 },
  pellets: 1,
  adsSpreadMoa: 0.8,
  hipSpreadMoa: 360,
  bloomMoaPerShot: 0.6,
  bloomMoaCap: 4,
  bloomDecayMoaPerSecond: 3,
  moveSpreadMoaPerMps: 80,
  crouchSpreadScale: 0.4,
  airborneSpreadMoa: 300,
  recoilPattern: [
    { pitch: 4.5, yaw: 0.3 },
    { pitch: 4.2, yaw: -0.35 },
    { pitch: 4.0, yaw: 0.2 },
  ],
  recoilResetSeconds: 1,
  recoilRecoveryPerSecond: 3.5,
  adsFovDegrees: 18,
  adsSeconds: 0.55,
  adsSensitivityScale: 0.28,
  muzzleVelocity: 850,
} as const satisfies WeaponSpec;
